import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/input/text';
import Checkbox from 'relements/build/esm/input/checkbox';
import Modal from 'relements/build/esm/overlays/modal';
import Button from 'relements/build/esm/ui/button';

// Actions
import { createAlert } from '@src/actions/BotActions';

// Constants
import Icon from '@src/components/Icon';
import { LANGUAGE_CODE_TO_TITLE } from '../../../constants/Language';

import styles from './EntityCopyModal.scss';

export default class EntityCopyModal extends React.Component {
  static propTypes = {
    active: PropTypes.bool.isRequired,
    entityToCopy: PropTypes.shape({
      supported_languages: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
  };

  state = {
    languagesToCopy: [],
    entityName: '',
  };

  componentWillReceiveProps(nextProps) {
    if (!this.props.active && nextProps.active) {
      this.setState({
        languagesToCopy: nextProps.entityToCopy.supported_languages || [],
      });
    }
  }

  render() {
    const { languagesToCopy, entityName } = this.state;
    const { entityToCopy, active } = this.props;
    const {
      supported_languages: supportedLanguages = [],
      entity_type: entityType,
    } = entityToCopy;
    const filteredLanguages = entityType === 'text' ? supportedLanguages : [];
    return (
      <Modal active={active}>
        <div className={styles.modal}>
          <div className={styles.modalHeader}>
            <Icon
              onClick={this.props.onClose}
              iconType="close"
              className={styles.modalHeaderIcon}
            />
            <div className={styles.modalHeaderTitle}>Copy entity</div>
          </div>
          <div className={styles.modalBody}>
            <Text
              autoFocus
              value={entityName}
              onChange={value => this.setState({ entityName: value })}
              placeholder="Entity Name"
              label="Name of new entity"
              hint="Only Lower case alphabets and underscores are allowed."
              className={styles.modalBodyInput}
            />
            {filteredLanguages.length > 1 ? (
              <Checkbox.Item
                value={!!(filteredLanguages.length === languagesToCopy.length)}
                onChange={this.handleAll}
                className={styles.modalBodyCheckbox}
                label="All"
              />
            ) : null}
            {filteredLanguages.map(language => (
              <Checkbox.Item
                key={language}
                value={languagesToCopy.includes(language)}
                onChange={this.handleChange(language)}
                className={styles.modalBodyCheckbox}
                label={LANGUAGE_CODE_TO_TITLE[language]}
              />
            ))}
          </div>
          <div className={styles.modalFooter}>
            <Button
              onClick={this.props.onClose}
              className={styles.modalFooterCTA}
            >
              Cancel
            </Button>
            <Button
              onClick={this.handleCopy}
              type={Button.TYPES.PRIMARY}
              disabled={entityName.length === 0}
              className={styles.modalFooterCTA}
            >
              Copy Entity
            </Button>
          </div>
        </div>
      </Modal>
    );
  }

  handleChange = language => () => {
    const selectedLanguages = this.state.languagesToCopy;
    const languageIndex = selectedLanguages.indexOf(language);

    let filteredLanguages = [];
    if (languageIndex > -1) {
      filteredLanguages = selectedLanguages.filter(
        (_, i) => i !== languageIndex
      );
    } else {
      filteredLanguages = selectedLanguages.concat([language]);
    }

    this.setState({ languagesToCopy: filteredLanguages });
  };

  handleAll = () => {
    const { entityToCopy } = this.props;
    const { supported_languages: supportedLanguages = [] } = entityToCopy;

    if (this.state.languagesToCopy.length === supportedLanguages.length) {
      this.setState({ languagesToCopy: [] });
    } else {
      this.setState({ languagesToCopy: supportedLanguages });
    }
  };

  handleCopy = () => {
    const name = this.state.entityName;

    if (name.length < 3) {
      createAlert('Please specify a longer Entity Name.', null, 'NEGATIVE');
      return;
    }

    const pattern = new RegExp('^[a-z][a-zs_]+[a-z]+$');
    if (!pattern.test(name)) {
      createAlert(
        'Entity Name can contain only small letters and underscore',
        null,
        'NEGATIVE'
      );
      return;
    }

    this.props.onCopy({
      srcName: this.props.entityToCopy.name,
      dstName: this.state.entityName,
      languageList: this.state.languagesToCopy,
    });

    this.props.onClose();
  };
}
